import { calculateCupAmounts } from '../recipe/recipeCalculations';

const getIngredientName = (smoothiePart, index) => smoothiePart?.flavor?.name || `Ingredient ${index + 1}`;

const normalizeCell = (value) => String(value ?? '').replace(/[\t\r\n]+/g, ' ').trim();
const roundGrams = (value) => (typeof value === 'number' && Number.isFinite(value) ? Math.round(value) : value);

export const buildMachineRecipeAmountGroups = (assignments, recipes, cupConfiguration) => {
	if (!Array.isArray(assignments) || !Array.isArray(recipes)) {
		return [];
	}

	const recipesById = new Map(recipes.map((recipe) => [recipe.id, recipe]));

	return [...assignments]
		.sort((first, second) => Number(first.index) - Number(second.index))
		.flatMap((assignment) => {
			const recipe = recipesById.get(assignment.recipeId);
			if (!recipe || !Array.isArray(recipe.smoothieParts)) {
				return [];
			}

			const amounts = cupConfiguration
				? calculateCupAmounts(
						recipe.smoothieParts,
						cupConfiguration.cupSize,
						recipe.waterRatio,
						recipe.weightRatio,
					)
				: null;

			return [{
				recipeId: recipe.id,
				recipeName: recipe.name || 'Unnamed recipe',
				recipeType: recipe.recipeType,
				waterGrams: amounts?.amountOfWater ?? null,
				totalIngredientGrams: amounts?.totalIngredientGrams ?? null,
				weightRatio: recipe.weightRatio,
				waterRatio: recipe.waterRatio,
				blendConfiguration: recipe.blendConfiguration,
				steamConfiguration: recipe.steamConfiguration,
				ingredients: recipe.smoothieParts.map((smoothiePart, ingredientIndex) => ({
					ingredientName: getIngredientName(smoothiePart, ingredientIndex),
					percentage: smoothiePart.percentage,
					grams: amounts?.ingredientGrams[ingredientIndex] ?? null,
				})),
			}];
		});
};

const spreadsheetHeaders = [
	'Recipe',
	'Ingredient',
	'Percentage (%)',
	'Grams (g)',
	'Recipe type',
	'Water (g)',
	'Total ingredients (g)',
	'Weight ratio',
	'Water ratio',
	'Blend (ms)',
	'Steam (ms)',
];

const toSpreadsheetRows = (groups) => [
	spreadsheetHeaders,
	...groups.flatMap((group) =>
		group.ingredients.map((ingredient, index) => [
			index === 0 ? group.recipeName : '',
			ingredient.ingredientName,
			ingredient.percentage,
			roundGrams(ingredient.grams),
			index === 0 ? group.recipeType : '',
			index === 0 ? roundGrams(group.waterGrams) : '',
			index === 0 ? roundGrams(group.totalIngredientGrams) : '',
			index === 0 ? group.weightRatio : '',
			index === 0 ? group.waterRatio : '',
			index === 0 ? group.blendConfiguration : '',
			index === 0 ? group.steamConfiguration : '',
		]),
	),
];

export const machineRecipeAmountsToTsv = (groups) =>
	toSpreadsheetRows(groups).map((row) => row.map(normalizeCell).join('\t')).join('\n');

export const machineRecipeAmountsToCsv = (groups) => {
	const quote = (value) => `"${normalizeCell(value).replace(/"/g, '""')}"`;
	return toSpreadsheetRows(groups).map((row) => row.map(quote).join(',')).join('\n');
};
